import { useState, useEffect, useRef } from 'react';
import { Link } from 'react-router-dom';
import { Redirect } from 'react-router-dom';
import { api_crud_route, data_interface, endpoints } from './Config';
import Hosts from '../../../Hosts';
import { getTokenInfo } from '../../../UseToken';
import Loader from '../../Loader/Loader';
import Swal from 'sweetalert2'
import { language } from './Language';
import {
	reqGET,
	reqPOST,
	reqDELETE,
	reqPUT,

} from '../../../Utils';
import { icon } from '../../WEBContent/Icon';
import { color } from '../../WEBContent/Color';

export default function Regist(props) {
	const [, set_dados] = useState(null);
	const dados = useRef(null);
	const [lang, set_lang] = useState('pt');
	const [isloading, setLoading] = useState(true);
	const [refresh, setRefresh] = useState(0);
	const [isRedirect, setRedirect] = useState(false);
	const [show_delete_button, set_show_delete_button] = useState(false);
	const [is_edit, set_is_edit] = useState(false)

	const [userAdmin, setUserAdmin] = useState([]);
	const [allResponsaveis, setAllResponsaveis] = useState([]);
	const [responsaveis, setResponsaveis] = useState([]);

	const [softwareNameInput, setSoftwareNameInput] = useState([]);
	const [selectedTypes, setSelectedTypes] = useState([]);

	/*
	Softwares
		{ id: 1, nome: 'SimAlimentação' },
		{ id: 2, nome: 'SimPan' },
		{ id: 3, nome: 'SimFact' },
		{ id: 4, nome: 'SimBeet' },
		{ id: 5, nome: 'SimRest' }
	*/

	const handleRowClick = (id) => {
		document.getElementById('c_' + id)?.click();
	};

	///////////////////////////////////////////////////////////////////////////////////////

	const custom_label_styles = {
		color: color.corShadow.hexa,
		padding: "1px 15px",
		fontSize: '14px',
	}

	const custom_input_styles = {
		borderRadius: "35px",
		padding: "10px 20px",
		fontSize: "14px",
		border: "1px solid #ced4da",
		outline: "none",
	};

	const fetch_id_info = async (id_serch) => {
		return await reqGET(`${api_crud_route}/${getTokenInfo().companycode}/${id_serch}`)
			.then(res => {
				set_dados(dados.current = res.data[0]);
				//PERSON_RESPONSABLE com responsáveis profil em 'Administrador'
				let aux_responsaveis = []
				if (res.data[0].info.person_responsable !== undefined && res.data[0].info.person_responsable.length > 0) {
					res.data[0].info.person_responsable.forEach(responsaveis => {
						aux_responsaveis.push(responsaveis)
					})
				}
				//console.log('Data', res)
				setSelectedTypes(res.data[0].info.selectedTypes);
				setResponsaveis(aux_responsaveis);
			})
			.catch(error => console.log(error)/*TODO: GO TO FAIL FETCH*/)
	}

	const clean_data = () => {
		// DEEP COPY OF data_interface 
		set_dados(dados.current = JSON.parse(JSON.stringify(data_interface)))
		set_dados(dados.current.info.companycode = getTokenInfo().companycode)
		//console.log(dados.current)
	}

	useEffect(() => {
		clean_data();
		set_lang(localStorage.getItem('lang'))

		try {
			let test = props.location.state.operation;

			if (test === 'edit') {
				//set_disabled(true)

				set_is_edit(true)

				set_show_delete_button(true)

				fetch_id_info(props.location.state.item['id']).then(() => {
					setLoading(false)
				})
				return
			}
			else {

				clean_data()

				setLoading(false);

				setRedirect(false);

			}

		} catch {
			clean_data()

			setLoading(false);

			setRedirect(false);
			return
		}

		return () => {
			clean_data()
		}

	}, [props])

	function apagar() {
		Swal.fire({
			title: language[lang].delete_title,
			text: language[lang].delete_text,
			icon: 'question',
			showCancelButton: true,
			confirmButtonColor: '#0095e8',
			cancelButtonColor: '#d9214e',
			confirmButtonText: language[lang].delete_confirm,
			cancelButtonText: language[lang].delete_cancel
		})
			.then((result) => {
				if (result.isConfirmed) {
					reqDELETE(api_crud_route, { id: dados.current.id })
						.then(() => {
							props.history.push(endpoints.list);
						})
						.catch(error => console.log(error))
				}
			})
			.catch((erro) => {
				console.log(erro)
			})

	};

	const handleCheckboxChange = (id) => {
		setSelectedTypes((prevTypes) =>
			prevTypes.map((type) =>
				type.id === id ? { ...type, state: !type.state } : type
			)
		);
	};

	const handleAddType = () => {
		if (!softwareNameInput.trim()) return;

		const newId = selectedTypes.length > 0
			? Math.max(...selectedTypes.map((type) => type.id)) + 1
			: 1;

		const newType = { id: newId, nome: softwareNameInput, state: true };

		setSelectedTypes([...selectedTypes, newType]);
		setSoftwareNameInput("");
	};

	const handleRemoveType = (id) => {
		setSelectedTypes(selectedTypes.filter((type) => type.id !== id));
	};

	function hex2rgb(value) {
		var hex_color = value
		var pattern_color = "^#([A-Fa-f0-9]{6})$";
		if (hex_color.match(pattern_color)) {
			var hex_color_aux = hex_color.replace("#", "")
				, r = parseInt(hex_color_aux.substring(0, 2), 16)
				, g = parseInt(hex_color_aux.substring(2, 4), 16)
				, b = parseInt(hex_color_aux.substring(4, 6), 16);
			return '' + r + ',' + g + ',' + b + '';
		}
		else {
			alert('Error Color Format');
		}
	}

	const handle_change_info_color = (e) => {
		const { name, value } = e.target;

		if (dados.current.info.color === undefined) {
			dados.current.info.color = { primary: '', primary_rgb: '', secondary: '' }
		}

		let color_rgb = hex2rgb(value)

		if (name === 'primary') {
			dados.current.info.color['primary_rgb'] = color_rgb
		}

		dados.current.info.color[name] = value

		set_dados(dados.current.info)
		setRefresh(refresh + 1)
		//console.log('«««««««««««««««««««««««')
		//console.log('Dados Current:' + JSON.stringify(dados))
	}

	const handleSubmit = async (e) => {
		e.preventDefault();

		try {
			const departmentId = dados.current.id;
			dados.current.info.person_responsable = responsaveis;

			dados.current.info.selectedTypes = selectedTypes.map(type => ({
				id: type.id,
				nome: type.nome,
				state: type.state
			}));

			if (is_edit === true) {
				const response = await reqGET(`https://web403.assec.net/api/simnet_genuine_website/intranet/departments/exists/${getTokenInfo().companycode}/${dados.current.info.name}/${dados.current.info.localidade}`);
				//console.log("API Response", response);

				if (Array.isArray(response.data) && response.data.length > 0 && response.data[0].id !== departmentId) {
					Swal.fire({
						title: 'Erro',
						text: 'Já existe um departamento com esse nome nessa localidade!',
						icon: 'error',
						confirmButtonText: 'OK',
					});
					return;
				}

				Swal.fire({
					title: language[lang].edit_title,
					text: language[lang].edit_text,
					icon: 'question',
					showCancelButton: true,
					confirmButtonColor: '#0095e8',
					cancelButtonColor: '#d9214e',
					confirmButtonText: language[lang].edit_confirm,
					cancelButtonText: language[lang].edit_cancel

				}).then(async (result) => {
					if (result.isConfirmed) {
						try {
							await reqPUT(api_crud_route, dados.current);
							window.location.reload();
							//props.history.push(endpoints.list);

						} catch (error) {
							Swal.fire(language[lang].edit_error, '', 'info');
						}
					}
				});
			} else {
				const response = await reqGET(`https://web403.assec.net/api/simnet_genuine_website/intranet/departments/exists/${getTokenInfo().companycode}/${dados.current.info.name}/${dados.current.info.localidade}`);

				if (Array.isArray(response.data) && response.data.length > 0) {
					Swal.fire({
						title: 'Erro',
						text: 'Já existe um departamento com esse nome nessa localidade!',
						icon: 'error',
						confirmButtonText: 'OK',
					});
					return;
				}

				Swal.fire({
					title: language[lang].insert_title,
					text: language[lang].insert_text,
					icon: 'question',
					showCancelButton: true,
					confirmButtonColor: '#0095e8',
					cancelButtonColor: '#d9214e',
					confirmButtonText: language[lang].insert_confirm,
					cancelButtonText: language[lang].insert_cancel

				}).then(async (result) => {
					if (result.isConfirmed) {
						try {
							await reqPOST(api_crud_route, dados.current);
							props.history.push(endpoints.list);
							window.location.reload();
						} catch (error) {
							Swal.fire(language[lang].insert_error, '', 'info');
						}
					}
				});
			}

		} catch (error) {
			console.error("Erro ao verificar a existência do departamento:", error);
			Swal.fire({
				title: 'Erro',
				text: 'Ocorreu um erro ao verificar a existência do departamento.',
				icon: 'error',
				confirmButtonText: 'OK',
			});
		}
	};

	const handle_change_info = (e) => {
		const { name, value } = e.target;

		let updatedData = { ...dados.current };

		updatedData.info[name] = value;

		set_dados(updatedData);
	};

	const fetch_administradores = async () => {
		try {
			const res = await reqGET(`${Hosts.SIMCore_API}/entities/list/${getTokenInfo().companycode}/Administrador`);
			setUserAdmin(res.data);
			//console.log('Administradores', res)
		} catch (error) {
			console.error("Erro ao buscar os Administradores:", error);
		}
	};
	
	const fetch_responsaveis = async () => {
		try {
			let res_entidade = await reqGET(`${Hosts.SIMCore_API}/entities/list/${getTokenInfo().companycode}/*`);
			let result = [];

			if (res_entidade.data !== undefined) {
				result = res_entidade.data.filter(el => el.entity_type === "1");
			}

			setAllResponsaveis(result);
			//console.log('Responsáveis', result);

		} catch (error) {
			console.error("Erro ao buscar as Entidades:", error);
			return [];
		}
	};

	const handleSingleCheckState = () => {
		set_dados(dados.current.info.state = !dados.current.info.state)
	}

	useEffect(() => {
		fetch_administradores();
		fetch_responsaveis();
	}, []);

	return isloading ?

		<Loader />

		:

		isRedirect
			?
			<Redirect to={endpoints.list} replace />
			:
			<main id="departamento-regist">
				<div className={`dash-cards header`}>
					<div >
						<h2 className="dash-title" >{language[lang].category}</h2>
						<p className='mb-3' >{language[lang].category} / {dados.current.id !== '' ? language[lang].category_edit : language[lang].category_edit}</p>
					</div>

					<div className={`dash-cards body`} >
						<div className="card mb-5 mb-xl-10 ">
							<div>
								<form id="form" onSubmit={handleSubmit}>
									<div className="card-body">
										<div className="row mb-6">
											{/* Departamento */}
											<div className="col-md-6 mt-1 my-3">
												<label
													className="fs-5 fw-bold mb-2"
													style={custom_label_styles}
												>
													{language[lang].depart_name}
												</label>
												<input
													type="text"
													name="name"
													value={dados.current.info.name}
													className="form-control"
													style={custom_input_styles}
													placeholder={language[lang].name_placeholder}
													onChange={handle_change_info}
													required
												/>
											</div>

											{/* Estado */}
											<div className="col-md-6 mt-2 my-3">
												<label className="fs-5 fw-bold mb-2">{language[lang].table_state}</label>
												<div className="input-group">
													<label className="switch">
														<input
															id="item-switch-state"
															name="state"
															className="form-control"
															type="checkbox"
															value={dados.current.info.state}
															onChange={handleSingleCheckState}
															defaultChecked={dados.current.info.state}
														/>
														<span className="slider" htmlFor="item-switch-state"></span>
													</label>
												</div>
											</div>
										</div>

										<div className="row mb-6 mt-4 my-3">
											{/* Sede */}
											<div className="col-md-6 mt-1 my-3">
												<label
													className="fs-5 fw-bold mb-2"
													style={custom_label_styles}
												>
													{language[lang].sede}
												</label>
												<input
													type="text"
													name="localidade"
													value={dados.current.info.localidade}
													className="form-control"
													style={custom_input_styles}
													placeholder="Lisboa, Porto..."
													onChange={handle_change_info}
												/>
											</div>

											{/* Cor Primária */}
											<div className="col-md-3 mt-2 my-3">
												<label
													className="fs-5 fw-bold mb-2"
													style={custom_label_styles}
												>
													{language[lang].color_primary}
												</label>
												<div className="input-group">
													<input
														type="color"
														name="primary"
														value={dados.current.info?.color?.primary || '#000000'}
														className="form-control p-0 border-0"
														style={{ width: '34px', height: '34px' }}
														onChange={handle_change_info_color}
													/>
													<span className="form-control rounded-0">{dados.current.info?.color?.primary}</span>
												</div>
											</div>

											{/* Cor Secundária */}
											<div className="col-md-3 mt-2 my-3">
												<label
													className="fs-5 fw-bold mb-2"
													style={custom_label_styles}
												>
													{language[lang].color_secondary}
												</label>
												<div className="input-group">
													<input
														type="color"
														name="secondary"
														value={dados.current.info?.color?.secondary || '#FFFFFF'}
														className="form-control p-0 border-0 rounded-0"
														style={{ width: '34px', height: '34px' }}
														onChange={handle_change_info_color}
													/>
													<span className="form-control rounded-0">{dados.current.info?.color?.secondary}</span>
												</div>
											</div>
										</div>

										<br />

										{/* Softwares  */}
										<div className="row mb-6 mt-4 my-3">
											<label
												className="fs-5 fw-bold"
												style={custom_label_styles}
											>
												{language[lang].softwares}
											</label>
											<div className="row">
												<table className="table my-4 table-hover w-100">
													<thead>
														<tr className="tr-line">
															<th scope="col"></th>
															<th scope="col"><strong>{language[lang].name}</strong></th>
															<th scope="col" className="text-end"><strong></strong></th>
														</tr>
													</thead>
													<tbody>
														{selectedTypes.map((type) => (
															<tr key={type.id}>
																<td>
																	<input
																		type="checkbox"
																		checked={type.state}
																		onChange={() => handleCheckboxChange(type.id)}
																		value={type.id}
																		className="form-check-input"
																		disabled={getTokenInfo().profile !== 'Administrador'}
																	/>
																</td>
																<td>{type.nome}</td>
																{(getTokenInfo().profile === 'Administrador') && (
																	<td className="text-end">
																		<button
																			type="button"
																			onClick={() => handleRemoveType(type.id)}
																		>
																			<i className={icon.trash.className} style={icon.trash.style}></i>
																		</button>
																	</td>
																)}
															</tr>
														))}
													</tbody>
												</table>
											</div>

											<div className="row mt-4">
												<div className="col-md-6 ms-auto">
													<div className="d-flex align-items-center justify-content-end">
														<input
															type="text"
															value={softwareNameInput}
															onChange={(e) => setSoftwareNameInput(e.target.value)}
															placeholder={language[lang].software_placeholder}
															className="form-control me-2"
															style={custom_input_styles}
														/>
														<button
															type="button"
															onClick={handleAddType}
															className="btn btn-outline-secondary btn-add-software"
															style={custom_input_styles}
														>
															{language[lang].add_new_software}
														</button>
													</div>
												</div>
											</div>
										</div>
									</div>
								</form>
							</div>
						</div>
					</div>
				</div>

				<div className={'dash-cards footer'}>
					<nav className="navbar bottom-navbar navbar-light">
						<div className="navbar-footer">
							<ul className="navbar-nav float-left"></ul>
							<ul className="navbar-nav float-right">
								<li className="nav-item">
									<Link className="nav-link btn-cancel" to={{ pathname: endpoints.list }}  >
										<i className="bi bi-chevron-left me-2"></i>
										<span>{language[lang].back}</span>
									</Link>
								</li>
								<li className={"nav-item " + show_delete_button}>
									<button onClick={() => apagar(dados.current.id)} className="nav-link btn-delete">
										<i className="bi bi-trash3 me-2"></i>
										<span>{language[lang].delete}</span>
									</button>
								</li>
								<li className="nav-item">
									<button type="submit" form="form" className="nav-link">
										<i className="bi bi-floppy me-2"></i>
										<span>{language[lang].save}</span>
									</button>
								</li>
							</ul>
						</div>
					</nav>
				</div>
			</main>
}